import {AoflElement, property, customElement} from '@aofl/element';
import {routerInstance, PathUtils} from '@aofl/router';
import {pages} from '@modules/constants-enumerate';

const WEBPACK_PUBLIC_PATH = __webpack_public_path__; // eslint-disable-line camelcase
const PUBLIC_PATH_REGEX = new RegExp('^' + WEBPACK_PUBLIC_PATH, 'i'); // eslint-disable-line camelcase

/**
 *
 * @class LinkToElement
 * @extends {AoflElement}
 */
@customElement('link-to')
class LinkToElement extends AoflElement {
  /**
   *
   * @readonly
   */
  static is = 'link-to';
  /**
   * @return {Object}
   */
  @property({converter(value) {
    let href = PathUtils.removeLeadingSlash(value.replace(PUBLIC_PATH_REGEX, ''));
    href = PathUtils.removeLeadingSlash(WEBPACK_PUBLIC_PATH + href, '');
    if (href !== pages.HOME) {
      href = '/' + href;
    }

    return href;
  }})
  href = '';
  @property({type: Boolean})
  ['disabled'] = false;
  @property({type: Boolean})
  ['track-url'] = false;
  @property({type: Boolean})
  ['track-url-partial'] = false;
  routerUnsubscribe = () => {};
  ctrlClick = false;

  @property({type: String, attribute: 'data-bi-id'})
  dataBiId = '';

  /**
   * Uses routerInstance to navigate to the requested page.
   * @param {Event} e
   * @return {void}
   */
  clickHandler = (e) => {
    if (this.disabled) return; // eslint-disable-line no-invalid-this

    if (this.ctrlClick) { // eslint-disable-line no-invalid-this
      window.open(this.href, '_blank'); // eslint-disable-line no-invalid-this
      e.preventDefault();
    } else if (location.href.replace(location.origin, '') !== this.href) { // eslint-disable-line no-invalid-this
      try {
        routerInstance.navigate(this.href, {});
      } catch (e) {}
    }
  }

  keydownHandler = (e) => {
    if (e.which === 17 || e.which === 91) {
      this.ctrlClick = true; // eslint-disable-line no-invalid-this
    }
  };

  keyupHandler = (e) => {
    if (e.which === 17 || e.which === 91) {
      this.ctrlClick = false; // eslint-disable-line no-invalid-this
    }
  };

  focusHandler = (e) => {
    this.ctrlClick = false; // eslint-disable-line no-invalid-this
  };
  /**
   * Check if path matches href.
   *
   * @private
   * @param {String} path
   */
  checkActive(path) {
    const cleanHref = PathUtils.removeTrailingSlash(PathUtils.cleanPath(this.href)) + '/';
    const cleanPath = PathUtils.removeTrailingSlash(PathUtils.cleanPath(path)) + '/';
    if (cleanHref === cleanPath) {
      this.classList.add('active');
    } else if (this['track-url-partial'] && cleanPath.indexOf(cleanHref) === 0) {
      this.classList.add('active');
    } else {
      this.classList.remove('active');
    }
  }

  connectedCallback() {
    super.connectedCallback();

    window.addEventListener('keydown', this.keydownHandler);
    window.addEventListener('keyup', this.keyupHandler);
    window.addEventListener('focus', this.focusHandler);
    this.addEventListener('click', this.clickHandler);

    if (this['track-url'] || this['track-url-partial']) {
      this.checkActive(location.pathname);
      this.routerUnsubscribe = routerInstance.after((request, response, next) => {
        this.checkActive(response.to);
        next(response);
      });
    }
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(
      (ctx, html) => html`
        <a href="${ctx.href}" @click="${(e) => e.preventDefault()}" ?disabled="${ctx.disabled}" @keypress="${this.clickHandler}" data-bi-id="${this.dataBiId}">
          <slot></slot>
        </a>`,
      [
        `a {
          color: inherit;
          text-decoration: inherit;
        }
        a:hover {
          color: inherit;
          text-decoration: inherit;
        }
        a:focus-visible {
          outline: 2px solid var(--red);
        },
        a[disabled] {
          cursor: not-allowed;
        }`
      ]
    );
  }

  disconnectedCallback() {
    window.removeEventListener('keyup', this.keyupHandler);
    window.removeEventListener('keydown', this.keydownHandler);
    window.removeEventListener('focus', this.focusHandler);
    this.removeEventListener('click', this.clickHandler);
    this.routerUnsubscribe();
    super.disconnectedCallback();
  }
}

export default LinkToElement;
